import { render } from "./FacilitiesModule.vue?vue&type=template&id=4c81c538&scoped=true"
import script from "./FacilitiesModule.vue?vue&type=script&lang=js"
export * from "./FacilitiesModule.vue?vue&type=script&lang=js"

import "./FacilitiesModule.vue?vue&type=style&index=0&id=4c81c538&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c81c538"

export default script